import { render, staticRenderFns } from "./breakout.config.vue?vue&type=template&id=f8e1b8ac"
import script from "./breakout.config.vue?vue&type=script&lang=js"
export * from "./breakout.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports